/**
 * Title — mirrors aidea.templateengine/src/slides/components/Title
 *
 * size: 'lg' | 'xl' | '2xl' | '3xl' | '4xl'   (maps to CSS --text-* tokens)
 * align: 'left' | 'center' | 'right'
 */
import React from "react";

/* eslint-disable react/prop-types */

const SIZE_MAP = {
  lg: "var(--text-lg)",
  xl: "var(--text-xl)",
  "2xl": "var(--text-2xl)",
  "3xl": "var(--text-3xl)",
  "4xl": "var(--text-4xl)",
};

export function Title({ children, size = "2xl", align = "left", style }) {
  return (
    <div
      className={`atomic-title atomic-title--${size}`}
      style={{
        fontFamily: "var(--font-heading)",
        fontWeight: "var(--font-heading-weight)",
        fontSize: SIZE_MAP[size] || SIZE_MAP["2xl"],
        color: "var(--color-text-primary)",
        lineHeight: 1.2,
        textAlign: align,
        margin: 0,
        ...style,
      }}
    >
      {children}
    </div>
  );
}

export default Title;
